import React, { useState, useEffect } from "react";
import tw from "tailwind-styled-components";
import Images from "../../Images";
import { useMutation } from "react-query";
import axios from "axios";
import Config from "../../Config";
import Loading from "../../Components/Loading";
import Table from "../../Components/Tenants/TableForExpiring";
import Navbar from "../../Components/Navbar";
import { toast } from "react-toastify";
import {
  BoxTitle,
  BoxContainer,
  BoxHead,
  Underline,
  FilterTableWrapper,
  FilterWrapper,
} from "../../Components/Styles/PageStyles";
import {
  FieldWrapper,
  InputGroup,
  Label,
} from "../../Components/Styles/InputStyles";
import { Field, Form, Formik } from "formik";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import EditTenantsModel from "../../Components/Tenants/EditTenants";
import ViewDetailModel from "../../Components/Tenants/ViewDetail";
import Kyc from "../../Components/Tenants/Kyc";
import moment from "moment";
import UploadDocument from "../../Components/Tenants/UploadDocument";
import SummaryCard from "../../Components/Tenants/SummaryCardForExpiring";
import NotFoundModel from "../../Components/NotFoundModel";
import { SummarySkeletonLoading } from "../../Components/SkeletonLoading";
import AgreementRenew from "../../Components/Tenants/AgreementRenew";
import SideModal from "../../Components/SideModal";
import PropertiesFilterDropdown from "../../Components/PropertiesFilterDropdown";

const TenantsAgreementExpiring = () => {
  const user = useSelector((state) => state.UserReducer.user);
  const property = useSelector(
    (state) => state.SelectPropertyReducer.selectProperty
  );
  const properties = useSelector((state) => state.PropertyReducer.property);
  const [selectedProperty, setSelectedProperty] = useState(property);

  const [isFocused, setIsFocused] = useState(false);

  const [addTenant, setAddTenant] = useState(false);
  const [selectedData, setSelectedData] = useState("");
  const [filterValue, setFilterValue] = useState("");
  const [isFirstTime, setIsFirstTime] = useState(true);
  const [filter, setFilter] = useState("");
  const [editUser, setEditUser] = useState(false);
  const [viewDetail, setViewDetail] = useState(false);
  const [uploadDocument, setUploadDocument] = useState(false);
  const [openKYCModel, setOpenKYCModel] = useState(false);
  const [apiData, setApiData] = useState();
  const [masterData, setMasterData] = useState();
  const [isRenewAgreement, setIsRenewAgreement] = useState(false);

  const [summaryData, setSummaryData] = useState({
    totalMovedOut: 0,
    curMonthMovedOut: 0,
    defaulters: 0,
    totalDefaultedDues: 0,
  });

  const { t, i18n } = useTranslation();
  const query = `propId=${selectedProperty?.id}&searchVal=&filter=${filter}&platform=3`;

  const fetchFunction = async () => {
    const response = await axios.get(
      `${Config.apiUrl}/tenant/web/agreement-expiring?${query}`,
      {
        headers: {
          authorization: "Bearer" + " " + user.token,
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
        },
      }
    );
    return response.data;
  };

  const getSuccess = (res) => {
    if (res.isSuccess === true) {
      setApiData(res?.list);
      setSummaryData(res?.stats);
      setMasterData(res?.list);
      // if (isFocused === false) setSummaryData(res?.stats);
      setIsFocused(true);
    } else {
      error = true;
    }
  };

  const getError = (res) => { };

  const {
    isLoading: isLoading,
    mutate: getListMutate,
    error,
    data,
    isRefetching,
    isFetching,
  } = useMutation(fetchFunction, {
    onSuccess: getSuccess,
    onError: getError,
  });

  useEffect(() => {
    if (!isFirstTime && !isFetching && !isRefetching && !isLoading) {
      sessionStorage.removeItem("tenant_expiring_page");
      const handler = setTimeout(() => {
        getListMutate();
      }, 100);

      return () => {
        clearTimeout(handler);
      };
    }
  }, [filter, selectedProperty]);

  useEffect(() => {
    const handler = setTimeout(() => {
      getListMutate();
      setIsFirstTime(false);
    }, 100);
    return () => {
      clearTimeout(handler);
    };
  }, [property]);


  // --------Upload Document---------
  const uploadDocumentFunction = async (values) => {
    const formData = new FormData();
    formData.append("clientId", values.id);
    formData.append("document", values.tenantDocumentImage);

    return await axios.post(`${Config.apiUrl}/uploadDocument`, formData, {
      headers: {
        authorization: "Bearer " + user.token,
        "Content-Type": "multipart/form-data",
      },
    });
  };

  const onUploadDocumentSuccess = (data) => {
    if (data?.data?.status === "OK") {
      toast.success(data?.data?.msg || "Document uploaded successfully!");
      apiData((prevData) =>
        prevData.map((owner) =>
          owner.id === selectedData.id
            ? { ...owner, documentPath: data.data.documentPath }
            : owner
        )
      );
    } else {
      toast.error(data?.data?.msg || "An error occurred.");
    }
    setUploadDocument(false);
    setSelectedData("");
  };

  const onUploadDocumentError = (error) => {
    toast.error(error?.response?.data?.msg || "An error occurred.");
    setUploadDocument(false);
  };
  const { isLoading: uploadDocumentLoading, mutate: uploadDocumentMutate } =
    useMutation(uploadDocumentFunction, {
      onSuccess: onUploadDocumentSuccess,
      onError: onUploadDocumentError,
    });

  //------- Edit Single Entry -------
  const EditTenantsFunction = async (values) => {
    const body = new FormData();
    body.append("id", values.id);
    body.append("name", values.name);
    body.append("mobile", values.mobile);
    body.append("status", values.status);
    body.append("occupation", values.occupation);
    body.append("gender", values.gender);
    body.append("email", values.email);
    body.append("kycStatus", values.kycStatus);
    body.append("moveInDate", values.moveInDate);
    body.append("agreementStartDate", values.agreementStartDate);
    body.append("rentalCycle", values.rentalCycle);

    return await axios.post(`${Config.apiUrl}/edittenant`, body, {
      headers: {
        authorization: "Bearer" + " " + user.token,
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
    });
  };

  const onEditEntrySuccess = (data) => {
    if (data?.data?.status == "OK") {
      toast.success(data?.data?.msg || "Success");
      setApiData(data.data);
    } else {
      toast.error(data?.data?.msg || "An Error Occured");
    }
    setSelectedData("");
    setEditUser(false);
  };

  const onEditEntryError = (data) => {
    setEditUser(false);
    setSelectedData("");
    toast.error(data?.data?.msg || "An Error Occured");
  };

  const { isLoading: editEntryLoading, mutate: editTenantsMutate } =
    useMutation(EditTenantsFunction, {
      onSuccess: onEditEntrySuccess,
      onError: onEditEntryError,
    });

  const onSummaryBoxClick = (data) => {
    sessionStorage.removeItem("tenant_expiring_page");
    let filteredData;
    const currentDate = moment().startOf("day");

    if (data === "ECM") { //Expiring Current Month
      const startOfMonth = currentDate.clone().startOf("month");
      const endOfMonth = currentDate.clone().endOf("month");

      filteredData = masterData.filter((tenantData) => {
        if (!tenantData.agreementExpiry) return false;

        const expiryDate = moment(tenantData.agreementExpiry);
        return expiryDate.isBetween(startOfMonth, endOfMonth, null, "[]");
      });
    } else if (data === "ENM") { //Expiring Next Month
      const startOfNextMonth = currentDate
        .clone()
        .add(1, "months")
        .startOf("month");
      const endOfNextMonth = currentDate
        .clone()
        .add(1, "months")
        .endOf("month");

      filteredData = masterData.filter((tenantData) => {
        if (!tenantData.agreementExpiry) return false;

        const expiryDate = moment(tenantData.agreementExpiry);
        return expiryDate.isBetween(
          startOfNextMonth,
          endOfNextMonth,
          null,
          "[]"
        );
      });
    } else if (data === "E") {
      filteredData = masterData.filter((tenantData) => {
        if (!tenantData.agreementExpiry) return false;

        const expiryDate = moment(tenantData.agreementExpiry);
        return expiryDate.isBefore(currentDate);
      });
    } else {
      filteredData = masterData;
    }
    setApiData(filteredData);
  };
  //------- Renew Agreement -------
  const renewAgreementFunction = async (values) => {
    return await axios.post(`${Config.apiUrl}/client/agreement/renew`, values, {
      headers: {
        authorization: "Bearer" + " " + user.token,
        "Content-Type": "application/json",
      },
    });
  };

  const onRenewAgreementSuccess = (data) => {
    if (data?.data?.isSuccess === true) {
      toast.success(data?.data?.msg || "Success");
      setIsRenewAgreement(false);
      getListMutate();
    } else {
      toast.error(data?.data?.msg || "An Error Occured");
    }
  };

  const onRenewAgreementError = (data) => {
    toast.error(data?.response?.data?.msg || "An Error Occured");
  };

  const { isLoading: renewAgreementLoading, mutate: renewAgreementMutate } =
    useMutation(renewAgreementFunction, {
      onSuccess: onRenewAgreementSuccess,
      onError: onRenewAgreementError,
    });

  const handleClose = () => {
    setIsRenewAgreement(false);
  };

  const handlePropertySelect = (property) => {
    sessionStorage.removeItem("tenant_expiring_page");
    setSelectedProperty(property);
  };

  return (
    <>
      <BoxContainer>
        <BoxHead>
          <BoxTitle className="!mb-0 whitespace-nowrap">
            Expiring Agreement
            <Underline />
          </BoxTitle>
        </BoxHead>

        <SideModal
          isOpen={isRenewAgreement}
          onClose={() => setIsRenewAgreement(false)}
        >
          <AgreementRenew
            renewAgreementMutate={renewAgreementMutate}
            isRenewAgreement={isRenewAgreement}
            renewAgreementLoading={renewAgreementLoading}
            setIsRenewAgreement={setIsRenewAgreement}
            handleClose={handleClose}
            selectedData={selectedData}
          />
        </SideModal>

        {editUser && (
          <EditTenantsModel
            editTenantsMutate={editTenantsMutate}
            editEntryLoading={editEntryLoading}
            setEditUser={setEditUser}
            data={data?.data}
            selectedData={selectedData}
          />
        )}

        {viewDetail && (
          <ViewDetailModel
            setViewDetail={setViewDetail}
            selectedData={selectedData}
          />
        )}

        {uploadDocument && (
          <UploadDocument
            uploadDocumentMutate={uploadDocumentMutate}
            uploadDocumentLoading={uploadDocumentLoading}
            setUploadDocument={setUploadDocument}
            selectedData={selectedData}
            data={data?.data}
          />
        )}

        {openKYCModel && (
          <Kyc setOpenKYCModel={setOpenKYCModel} selectedData={selectedData} />
        )}

        {(isLoading || isRefetching) && !isFocused && (
          <SummarySkeletonLoading count={3} />
        )}
        {isFocused && apiData && (
          <SummaryCard summaryData={summaryData} onClick={onSummaryBoxClick} />
        )}

        {!error && !isLoading && apiData && (
          <FilterTableWrapper className='pt-2'>
            <FilterWrapper className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <>
                {/* <div className="flex gap-2 justify-end items-center px-4 py-2">
                  <Text>Total records: {apiData?.length || 0}</Text>
                </div> */}

                {/* Left: Total Record */}
                <div className="flex items-center">
                  <Text>
                    Total records:{" "}
                    <span className="font-semibold">
                      {apiData?.length || 0}
                    </span>
                  </Text>
                </div>

                <div className="flex gap-2 justify-end items-center">
                  <PropertiesFilterDropdown
                    properties={properties}
                    selectedProperty={selectedProperty}
                    onPropertySelect={handlePropertySelect}
                    placeholder="Select Property"
                    className="min-w-[200px] ml-auto"
                  />
                </div>
              </>
            </FilterWrapper>
            <TableWrapper>
              <Table
                apiData={error ? [] : apiData?.length > 0 ? apiData : []}
                setSelectedData={setSelectedData}
                selectedData={selectedData}
                setEditUser={setEditUser}
                setViewDetail={setViewDetail}
                setUploadDocument={setUploadDocument}
                userType={user.userType}
                setOpenKYCModel={setOpenKYCModel}
                setIsRenewAgreement={setIsRenewAgreement}
              />
              {(error || apiData.length === 0) && !isLoading && <NotFoundModel msg={"All good! No leases are expiring."} />}
            </TableWrapper>
          </FilterTableWrapper>
        )}
        {(isLoading || isRefetching) && <Loading />}
        {error && !isLoading && <NotFoundModel />}
      </BoxContainer>
    </>
  );
};

const Filters = ({
  initialValues,
  submitHandler,
  InitialLoading,
  user,
  setAddTenant,
}) => {
  return (
    <Formik initialValues={initialValues} onSubmit={submitHandler}>
      <Form>
        <FilterContainer>
          <InputGroup className="max-w-xs ">
            <Label htmlFor="startDate">Start Date:</Label>
            <FieldWrapper className="h-10">
              <img
                src={Images.Calender}
                alt="Calender icon"
                className="w-3.5"
              />
              <Field
                type="date"
                name="startDate"
                id="startDate"
                className="ml-1"
              />
            </FieldWrapper>
          </InputGroup>

          <InputGroup className="max-w-xs ">
            <Label htmlFor="endDate">End Date:</Label>
            <FieldWrapper className="h-10">
              <img
                src={Images.Calender}
                alt="Calender icon"
                className="w-3.5"
              />
              <Field type="date" name="endDate" id="endDate" className="ml-1" />
            </FieldWrapper>
          </InputGroup>

          <ApplyBtn disabled={InitialLoading} type="submit">
            Apply Filter
          </ApplyBtn>
          <ApplyBtn
            type="button"
            onClick={() => {
              setAddTenant(true);
            }}
          >
            {"Add Tenant"}
          </ApplyBtn>
        </FilterContainer>
      </Form>
    </Formik>
  );
};

const TableWrapper = tw.h1`mt-2 bg-white rounded-md `;
const Title = tw.h1`text-xl  text-gray-800 whitespace-nowrap   font-medium`;
const UploadWrapper = tw.div`w-full flex justify-end space-x-4 items-center `;
const FilterContainer = tw.div`
grid grid-cols-2 w-full gap-4 md:flex md:space-x-4 items-end mt-0 md:mt-0`;
const Text = tw.p`text-gray-500 text-sm font-normal `;

const ApplyBtn = tw.button`${(p) =>
  p.$active
    ? "bg-gray-100"
    : ""} border whitespace-nowrap border-gray-200 flex space-x-1.5 justify-center items-center text-white h-full rounded-md px-6  cursor-pointer bg-primary-color hover:bg-hover-color py-[.550rem] text-sm`;
export default TenantsAgreementExpiring;
